import styled from 'styled-components';

export const FormMessageStyled = styled.div`
  margin-top: 8px;
  margin-bottom: ${(props) => props?.marginBottom || 'unset'};
  font-family: 'inter-regular', sans-serif;
  font-weight: 400;
  font-size: 16px;
`;
